export default __webpack_public_path__ + "static/media/goat.59168066.png";